import type { DestinationID, ImposeResult } from "@pdfking/imposition"
import { PlotLayers } from "@pdfking/imposition-form"
import { Keys } from "@pdfking/tfunc"

import type { LazyPage } from "#public"

/** The result's sheets as the viewer lays them out. Active guides pick the
 * destinations drawn, and the marks guide the printable layers only; none
 * given is the default preview — every destination, every layer. */
export const ResultPages = (result: ImposeResult): LazyPage[] => {
  const all = Keys(result.destinations) as DestinationID[]
  return result.sheets.map(sheet => ({
    ...sheet.position,
    bleed: sheet.bleed,
    get_page: active_guides =>
      sheet.shapes(
        active_guides
          ? active_guides.filter(g => g.kind === "destination").map(g => g.id as DestinationID)
          : all,
        PlotLayers(!!active_guides?.some(g => g.kind === "marks"))
      ),
  }))
}
